webpackJsonp([11],{

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(951),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            name: "Central<br/>Analytics<br/>Repository"
        };
    },

    methods: {
        lookUp: function lookUp() {
            return this.name;
        }
    }
});

/***/ }),

/***/ 951:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', [_vm._v("Welcome to Admin Settings Page")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "red",
      "large": ""
    }
  }, [_c('small', {
    staticStyle: {
      "font-size": "9px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.lookUp())
    }
  })])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.17269dfbb63d942cb520.js